import guestRegisterActions from "@frameworks/web/redux/feature/LoginFlow/actions/guestRegister";
import GetAccountDetailsActions from "@frameworks/web/redux/feature/LoginFlow/actions/getAccountDetails";
import GuestValidateMPINActions from "@frameworks/web/redux/feature/LoginFlow/actions/guestValidateMPIN";
import ClientLoginDataAction from "@frameworks/web/redux/feature/LoginFlow/actions/ClientLoginData";
import UnblockUserActions from "@frameworks/web/redux/feature/LoginFlow/actions/unblockUser";
import ClientForgotUserIDActions from "@frameworks/web/redux/feature/LoginFlow/actions/ClientForgotUserID";
import ClientGenOTPActions from "@frameworks/web/redux/feature/LoginFlow/actions/ClientGenOTP";
import ClientSetPasswordActions from "@frameworks/web/redux/feature/LoginFlow/actions/ClientSetPassword";
import ClientValPasswordActions from "@frameworks/web/redux/feature/LoginFlow/actions/ClientValPassword";
import ClientValOTPActions from "@frameworks/web/redux/feature/LoginFlow/actions/ClientLoginValOTP";
import GuestEmailVerifyOTPActions from "@frameworks/web/redux/feature/LoginFlow/actions/GuestEmailVerifyOTP";
import UpdateAccountDetails from "@frameworks/web/redux/actions/userDetails";
export default () => {
    return {
        login: {
            guestRegisterActions: new guestRegisterActions(),
            getAccountDetails: new GetAccountDetailsActions(),
            guestValidateMPIN: new GuestValidateMPINActions(),
            clientLoginDataActions: new ClientLoginDataAction(),
            unblockUser: new UnblockUserActions(),
            clientForgotUserID: new ClientForgotUserIDActions(),
            clientGenOTP: new ClientGenOTPActions(),
            clientSetPass: new ClientSetPasswordActions(),
            clientValPass: new ClientValPasswordActions(),
            clientValOTP: new ClientValOTPActions(),
            guestRegEmailVerifyOTP: new GuestEmailVerifyOTPActions(),
            updateAccountDetails: new UpdateAccountDetails(),
        },
    };
};
